(function () {
  if (window.__varionPreorderLoaded) return;
  window.__varionPreorderLoaded = true;

  var preorderButtonSelector = '[data-varion-cart-intent="preorder"], .is-varion-preorder';

  function normalizePreorderCopy(root) {
    var scope = root || document;

    scope.querySelectorAll(preorderButtonSelector).forEach(function (button) {
      if (!button || button.classList.contains('varion-reserve-button')) return;

      var target =
        button.querySelector('span:not(.sold-out-message)') || button.querySelector('span') || button;
      var text = String((target && target.textContent) || '').trim();

      if (/sold|ausverkauft|nicht verf/i.test(text)) return;

      if (target && (!text || /warenkorb|add to cart|vorbestellen|vorbestellbar|zur vorbestellung/i.test(text))) {
        target.textContent = 'Vorbestellen';
      }

      button.setAttribute('data-varion-cart-intent', 'preorder');
      button.setAttribute('data-varion-button-label', 'Vorbestellen');
      button.classList.add('is-varion-preorder');
    });
  }

  function runSoon(delay) {
    window.setTimeout(function () {
      normalizePreorderCopy(document);
    }, delay);
  }

  function boot() {
    normalizePreorderCopy(document);
    [250, 900, 1800].forEach(runSoon);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.name === 'id') {
      runSoon(120);
    }
  });
})();
